import template from './check.html';
import controller from './check.controller';

let checkComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default checkComponent;
